import {
  IConfigurationParams,
  ConfigurationNames,
} from '../../../../graphql/configuration/models/configuration.models';

export const getRuStoreEnabled = (configuration: IConfigurationParams[]): boolean => {
  const ruStoreParams = configuration?.find((
    params,
  ) => params.name === ConfigurationNames.ruStore);

  return ruStoreParams ? JSON.parse(ruStoreParams?.configuration)?.enabled : false;
};
